<template>

    <div class="container"
      style="width: 100%;margin: 0px;padding: 0px;max-width: 100%;min-height: max-content;z-index: 0;height: auto;overflow-y:hidden">
      <div class="row gx-0 gy-0 justify-content-center align-items-center"
        style="background: transparent;overflow-x: clip;min-height: 90vh;">
        <div class="col d-grid justify-content-xl-center align-items-xl-center zstack custom-col order-sm-1"
          style="background: transparent;overflow-x: visible;grid-column: 1;grid-row: 1;overflow-y: visible;padding-right: 1rem;padding-left: 1rem;">
          <div style="width: 100%;height: 100%;overflow-x: visible;place-self: center center;opacity: 1;">
            <div class="blurryCircle"
              style="background: rgb(13,110,253);width: 50vw;height: 50vw;min-height: 10rem;min-width: 10rem;place-self: end end;border-radius: 9999px;position: relative;/*left: 50%;*/top: 50%;z-index: -1;transform: translate3d(0, 0, 0);">
            </div>
          </div>
          <div
            class="text-center d-flex d-xl-flex flex-column justify-content-center align-items-center justify-content-xl-center align-items-xl-center zstack materialBackground"
            style="width: auto;border-radius: 15px;box-shadow: 0px 0px 19px rgba(0,0,0,0.24);aspect-ratio: 1/1;height: auto;overflow: clip;padding: 2rem;max-height: 30rem;">
            <h1 class="text-center" style="justify-self: start;margin-bottom: auto;">Reset Password</h1>

            <form @submit.prevent="sendPasswordReset" class="d-flex d-xl-flex flex-column px-5 justify-content-xl-center align-items-xl-center gap-2"
              style="width: 100%;height: 100%;">
  
              <input class="form-control" v-model="email" type="email" name="Email" placeholder="Email" inputmode="email" required="" style="margin-top: auto;">
              
              <button :disabled="sendingReset" class="btn btn-primary" type="submit" style="margin-top: auto;">Send Password Reset Email</button>
  
              <NuxtLink to="/resources/signup" type="submit" style="">Don't have an account?</NuxtLink>
  
          </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
  
  useHead({
    title: "Resource Hub - Reset Password | AIBoosted"
  })

  const email = ref("");
  
  const auth = getAuth();
  
  const sendingReset = ref(false)
  
  async function sendPasswordReset() {
    if (!email.value) {
      return;
    }
    sendingReset.value = true
    try {
      const redirectUrl = window.location.origin + "/resources/login"
      await sendPasswordResetEmail(auth, email.value, {
        url: redirectUrl
      })
      
      navigateTo({
        path: "/resources/login",
        query: {
            resetSent: true
        }
      })
    } catch (error) {
      alert('Error sending password reset email: ' + error.message);
    }
    sendingReset.value = false
  }
  </script>
  
  <style scoped>
  .text-danger {
    color: red;
  }
  </style>
  